import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useDebouncedCallback } from 'use-debounce';
import { flexGap2 } from '../../../../constants/lkCadastr/cadastrStorage';
import CustomInput from '../../../../components/Inputs';
import { useGetReport, getYear } from '../utils';
import { createReportRequest } from '../../../../api/reportApi';
import { fileTypes, report_type, reportTitles } from '../constants';
import { BACKGROUND_LIGHT } from '../../../../constants/colors';
import { getSubjectsRequest } from '../../../../api/subjectApi';
import { ReportTemplate } from './ReportTemplate';

const autocompleteOptionsStyle = {
  background: BACKGROUND_LIGHT,
  width: '175px',
};

const initialForm = {
  consolidatedYear: '',
  subject: null,
};

export function ConsolidatedReport() {
  const [subjects, setSubjects] = useState([]);
  const [loadingSubjects, setLoadingSubjects] = useState(false);
  const getReports = async ({ form }) => {
    try{
      return createReportRequest({
        format_type: fileTypes.xlsx,
        report_type,
        kind: reportTitles.consolidated_report_legal_entities,
        options: {year: getYear(form.consolidatedYear), inn: form.subject?.inn ?? ''},
      });
    } catch(error){
      console.error(error)
    }
  }

  const {
    form, onChange, makeRequest, clear, dateError,
  } = useGetReport({ initialForm, getReports, withDownload: true });

  const fetchSubjects = (searchValue) => {
    setLoadingSubjects(true);
    getSubjectsRequest({ params: { total: 10, search: searchValue }, shouldCache: true }).then((response) => {
      setSubjects(response.map((item) => ({
        value: item.id,
        inn: item.inn,
        name: item.name,
        label: `${item.name} (${item.inn})`,
      })));
    }).finally(() => setLoadingSubjects(false));
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  const makeAsyncSearch = useDebouncedCallback(async (newValue) => {
    fetchSubjects(newValue.search);
  }, 500);

  const { consolidatedYear, subject } = form;

  return (
    <ReportTemplate
      downloadOptions={{ disableDownload: !consolidatedYear || !subject, makeRequest }}
      error={dateError}
      clear={clear}
      visibleClear={consolidatedYear || subject}
      reportTitle="Параметры формирования"
    >
      <Box sx={{ ...flexGap2, flexDirection: 'row' }}>
        <CustomInput
          label="Год отчётного периода"
          name="consolidatedYear"
          value={consolidatedYear}
          onChange={onChange}
          type="number"
          maxLength={4}
          placeholder="ГГГГ"
        />
        <Autocomplete
          noOptionsText="Ничего не найдено"
          loadingText="Загрузка..."
          loading={loadingSubjects}
          sx={autocompleteOptionsStyle}
          onChange={(_, value) => {
            onChange({ target: { name: 'subject' } }, value);
          }}
          value={subject}
          getOptionLabel={(option) => option?.inn || ''}
          renderOption={(props, option) => (
            <li key={option.value} {...props}>
              {option.inn}
              {' '}
              —
              {option.name}
              {' '}
            </li>
          )}
          onInputChange={(_, inputValue) => {
            makeAsyncSearch({ search: inputValue });
          }}
          renderInput={(params) => (
            <TextField
              label="ИНН"
              {...params}
            />
          )}
          options={subjects}
        />
        <Autocomplete
          noOptionsText="Ничего не найдено"
          loadingText="Загрузка..."
          loading={loadingSubjects}
          sx={autocompleteOptionsStyle}
          value={subject}
          getOptionLabel={(option) => option?.name || ''} // показываем ИНН
          renderOption={(props, option) => (
            <li key={option.value} {...props}>
              {option.inn}
              {' '}
              —
              {option.name}
              {' '}
            </li>
          )}
          onInputChange={(_, inputValue) => {
            makeAsyncSearch({ search: inputValue });
          }}
          onChange={(_, value) => {
            onChange({ target: { name: 'subject' } }, value);
          }}
          renderInput={(params) => (
            <TextField
              label="Наименование"
              {...params}
            />
          )}
          options={subjects}
        />
      </Box>
    </ReportTemplate>
  );
}
